export function parseApiErrorMessage(rawMessage: string): { status?: number; message: string } {
  const match = /^HTTP (\d+): ([\s\S]*)$/.exec(rawMessage);
  if (!match) return { message: rawMessage };

  const status = Number(match[1]);
  const body = match[2];
  try {
    const parsed = JSON.parse(body);
    if (parsed?.error?.message) return { status, message: String(parsed.error.message) };
    if (Array.isArray(parsed?.detail) && parsed.detail.length > 0) {
      const messages = parsed.detail
        .map((d: { msg?: string }) => (d.msg ?? '').replace(/^Value error,\s*/, ''))
        .filter(Boolean);
      if (messages.length > 0) return { status, message: messages.join('. ') };
    }
    if (typeof parsed?.detail === 'string') return { status, message: parsed.detail };
  } catch {
    return { status, message: rawMessage };
  }

  return { status, message: rawMessage };
}

type JwtPayload = { exp?: number };

function parseJwtPayload(token: string): JwtPayload | null {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Failed to parse JWT token:', error);
    return null;
  }
}

export function isTokenExpired(token: string): boolean {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) return true;
  return Date.now() >= payload.exp * 1000 - 5 * 60 * 1000;
}
